import React, {useCallback} from 'react';
import {trimFileName} from '../../utils/notificationHelpers';
import TryAgainErrorNotification from '../common/TryAgainErrorNotification';
import i18n from '../../utils/i18n';
import Text from '@adsk/bim360-matrix-react-text';
import downloadAttachmentThunk from '../../app/thunk/attachmentDownloadThunk';
import {OSS_URN_TYPE} from '../../constants/attachments';
import {isImageAttachment} from '../../utils/attachmentsHelper';
import {openAttachmentAction, showAttachmentsInGallery} from '../../app/actions';

const useOpenAttachment = ({attachment, dispatch}) => {
  const downloadAttachment = useCallback(() => {
    const trimmedFileName = trimFileName(attachment.name, 35);
    const failureMessage = (
      <TryAgainErrorNotification
        message={i18n.t('notifications.failedToDownload', {fileName: trimmedFileName})}
        tryAgainAction={downloadAttachment}
      />
    );
    const asyncMessage = (
      <Text hasHTML>{i18n.t('notifications.preparingToDownload', {fileName: trimmedFileName})}</Text>
    );

    dispatch(downloadAttachmentThunk.downloadAttachment(attachment, asyncMessage, failureMessage));
  }, [attachment, dispatch]);

  return useCallback(() => {
    const {urnType} = attachment;

    if (urnType === OSS_URN_TYPE) {
      if (isImageAttachment(attachment)) {
        dispatch(showAttachmentsInGallery([attachment]));
      } else {
        downloadAttachment();
      }
    } else {
      dispatch(openAttachmentAction(attachment));
    }
  }, [attachment, dispatch, downloadAttachment]);
};

export default useOpenAttachment;
